import React, { useEffect, useRef, useState } from 'react'
import { Button, Input, message } from 'antd'
import styles from './index.module.less'
import {SActionBtn, SFuncModal, SIDRender, SLowcodeList, STableActions} from 'shj-components'
import config from './config.js'
import { fileConfirm } from '@/utils/file'
import AudioRecordConformity from './modal/audioRecordConformity'
import { getEnums, httpOrgList } from "@/services/homeService.ts";
import { getAudioRecordPage, exportAudioRecord, getSeatAccountList } from "@/services/crmTool.ts";
import { getAllCompanyMrn, getRealEstateList } from "@/services/customerServices.ts";
import { departmentTree } from "@/services/content.ts";
import { getUser } from "shj-utils";
import dayjs from "dayjs";
import { downloadExcel } from "@/services/evaluateConfig.ts";
import { useNavigate } from "react-router-dom";

export default function CallRecords(props: any) {
  const { setActiveKey, setClueId } = props
  const userInfo = getUser()
  const history = useNavigate()
  const listRef = useRef<any>()
  const [openAudioRecordConformity, setOpenAudioRecordConformity] = useState(false)
  const [params, setParams] = useState({
    callTimeBeginTime: '',
    callTimeEndTime: '',
  })
  const [modalData, setModalData] = useState({}) //弹框数据
  const [exportLoading, setExportLoading] = useState(false)
  const callQualifiedList = [
    { label: '合格', key: true },
    { label: '不合格', key: false },
    // { label: '空', key: 2 },
  ] //通话合格

  // 通话记录状态
  const stateName = {
    dealing: '已接听',
    notDeal: '振铃未接听',
    voicemail: '已留言',
    blackList: '黑名单',
    queueLeak: '排队放弃',
    leak: 'ivr',
  }
  const jumpCallDetails = (value: any) => {
    setActiveKey?.('1')
    setClueId?.(value)
  }
  // 简易弹窗
  const onPlay = (data: Record<string, any>) => {
    SFuncModal({
      width: 400,
      title: '播放',
      vanish: true,
      content: (
        <div style={{textAlign: 'center', padding: '10px 0'}}>
          <audio src={data.ossUrl} controls>
            浏览器不支持音频播放。
          </audio>
        </div>
      ),
    })
  }
  // 筛选搜索
  const filterSerchData = (objOld: any) => {
    if (!objOld.duration) {
      setParams({
        callTimeBeginTime: '',
        callTimeEndTime: '',
      })
    }
    const newObj = { ...objOld }

    if (Array.isArray(newObj.deptId)) {
      newObj.deptId = newObj.deptId[newObj.deptId.length - 1];
    }
    if (newObj.callTime) {
      newObj.callBeginTime = newObj.callTime[0] ? dayjs(newObj.callTime[0]).format('YYYY-MM-DD 00:00:00') : ''
      newObj.callEndTime = newObj.callTime[1] ? dayjs(newObj.callTime[1]).format('YYYY-MM-DD 23:59:59') : ''
    }
    if (params.callTimeBeginTime && objOld.duration) {
      newObj.callTimeBeginTime = params.callTimeBeginTime
    }
    if (params.callTimeEndTime && objOld.duration) {
      newObj.callTimeEndTime = params.callTimeEndTime
    }
    if (!newObj.clueId) {
      delete newObj.clueId
    }

    delete newObj.callTime
    delete newObj.duration
    return newObj
  }

  useEffect(() => {
    if(userInfo?.userIdentity?.dataScope !== 'ALL') {
      onCompanyChange(userInfo.companyId)
    }
  }, [userInfo])

  const fetchList = (values: any) => {
    return new Promise( (resolve, reject) => {
      try {
        const { current = 1, pageSize = 10, query = {} } = values
        const data = { ...query, orderBys: [{columnName: 'created_time', asc: false}] }
        const _param = filterSerchData(data)
        getAudioRecordPage({params: {pageId: current, pageSize}, data: _param})
          .then((_records: any) => {
            resolve({ records: _records?.list || [], total: _records?.count || 0 })
          })
          .finally(() => {
            reject({ success: false })
          })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  const getStatusOptions = () => {
    return Promise.all([
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.seat.CallState'),
      getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.seat.CallType'),
      httpOrgList(),
      getEnums("report", "com.shj.saas.report.enums.crm.AudioLogBrandEnum"),
    ]).then(res=>{
      const [answerState, callTypeList, companyList, serviceList] = res;
      console.log(serviceList, 111)
      return {answerState, callTypeList, callQualifiedList, companyList, serviceList}
    })
  }

  const onCompanyChange = async (value: any) => {
    if (value) {
      departmentTree(value, {
        "direction": "DOWN"
      }).then(res => {
        listRef?.current?.updateSearchData('deptId', res)
      })
      getAllCompanyMrn({userIdentityFilter: {companyId: value}}).then(res => {
        listRef?.current?.updateSearchData('employ', res)
      })

    } else {
      listRef?.current?.updateSearchData('deptId', [])
      listRef?.current?.updateSearchData('employ', [])

    }
  }

  const onDeptCodeChange = (value) => {
    if (value) {
      getAllCompanyMrn({directlyUnder: {orgId: value[value.length - 1], includeChild: true}}).then(res => {
        listRef?.current?.updateSearchData('employ', res)
      })
    } else {
      const companyId = listRef.current.getSearch()?.getFieldValue('orgId')
      if (companyId) {
        getAllCompanyMrn({userIdentityFilter: {companyId}}).then(res => {
          listRef?.current?.updateSearchData('employ', res)
        })
      } else {
        listRef?.current?.updateSearchData('employ', [])
      }
    }
  }

  const onExport = () => {
    const query = listRef.current.getSearch().getFieldsValue();
    const dataQuery = { ...query, orderBys: [{columnName: 'created_time', asc: false}] }
    const newData = filterSerchData(dataQuery)
    const data = {
      taskName: "外呼记录",
      reqParam: JSON.stringify(newData),
      taskCode: "AudioRecordExcelImpl",
      taskSource: "CRM",
      taskRemark: "外呼记录导出"
    }
    console.log(123,  data)
    message.loading({ content: '导出中' })
    downloadExcel(data)
      .then(() =>{
        history('/main/download');
      })
      .catch(() => {
        message.error('导出失败')
      })
  }
  // 刷新
  const reload = () => {
    const {
      current: { reload },
    } = listRef
    reload()
  }
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onExport, onCompanyChange, onDeptCodeChange },
    status: {
      exportLoading,
      orgDisabled: () => userInfo?.userIdentity?.dataScope !== 'ALL',
    },
    // auth,
    customRender: {
      idJump(text: any, record: any) {
        return (
            <SIDRender id={text} auth='null'/>
        )
      },
      callStateName(text: string) {
        return stateName[text]
      },
      operation(text: any, record: any) {
        return (
          <STableActions>
            {!record.ossUrl ? null : (
              <SActionBtn
                onClick={() => {
                  onPlay(record)
                }}
              >
                播放
              </SActionBtn>
            )}
            <SActionBtn
              onClick={() => {
                setModalData(record)
                setOpenAudioRecordConformity(true)
              }}
            >
              评定
            </SActionBtn>
          </STableActions>
        )
      },
      duration({ key, name, form }: any) {
        // 通话时长
        return (
          <div className={styles.callDuration}>
            <Input
              type="number"
              className={styles.input}
              min={0}
              style={{ border: 0, borderRadius: 0 }}
              onChange={(e: any) => {
                const value = e.target.value
                setParams({
                  ...params,
                  callTimeBeginTime: value,
                })
              }}
              placeholder="请输入"
              name="callTimeBeginTime"
            />
            <div style={{ lineHeight: '30px' }}>&nbsp;&nbsp;~&nbsp;&nbsp;</div>
            <Input
              type="number"
              id="2"
              className={styles.input}
              min={0}
              style={{ border: 0, borderRadius: 0 }}
              onChange={e => {
                const value = e.target.value

                setParams({
                  ...params,
                  callTimeEndTime: value,
                })
              }}
              placeholder="请输入"
              name="callTimeEndTime"
            />
          </div>
        )
      },
      exportRender(){
        return <Button onClick={onExport}>导出</Button>
      }
    },
  }

  return (
    <div>
      <SLowcodeList config={{ ...config, [userInfo?.userIdentity?.dataScope === 'ALL' ? '' : 'searchInitialValues']: {orgId: userInfo.companyId}}}
                    ref={listRef} searchMode="group" {...extension} />
      <AudioRecordConformity
        open={openAudioRecordConformity}
        onCancel={() => {
          setOpenAudioRecordConformity(false)
        }}
        data={modalData}
        fn={reload}
      />
    </div>
  )
}
